import type { SellerRatingsProps } from './SellerRatingsSummary.typed';
import * as Styled from './SellerRatingsSummary.styled';
import { InfoTitle } from '../../../../../components/Toolkit/InfoTitle/InfoTitle';
import { StarIc } from '@dsch/dd-icons';
import { useTheme } from 'styled-components';
import { LinkButton } from '../../../../../components/Toolkit/Button/LinkButton';
import { plural } from '@dist-marketplace-frontend/utils';

const SellerRatingsSummary = (props: SellerRatingsProps) => {
  const {
    membershipDuration,
    ratingAverage = '',
    ratingCategory,
    reviewCount = 0,
    className,
    onClickRatings,
    onClickReviews,
  } = props;
  const theme = useTheme();
  const hasRating = Boolean(ratingAverage);
  const hasReviews = reviewCount > 0;

  const ratingContent = (
    <>
      {ratingAverage && `${ratingAverage}/5`}
      <Styled.RatingStarIc color={theme.colors.ORANGE} width="16" height="16" />
    </>
  );

  const getRatingTitle = () => {
    if (!hasRating) {
      return (
        <Styled.IconWrapper>
          <StarIc color={theme.colors.GREY_DARKER} width="16" height="16" />
        </Styled.IconWrapper>
      );
    }

    if (onClickRatings) {
      return (
        <Styled.Rating onClick={onClickRatings} name="rating">
          {ratingContent}
        </Styled.Rating>
      );
    }

    return <Styled.RatingNoLink>{ratingContent}</Styled.RatingNoLink>;
  };

  const getReviewTitle = () => {
    if (!hasReviews) {
      return '0';
    }

    if (onClickReviews) {
      return (
        <LinkButton onClick={onClickReviews} fontSize="M16">
          {reviewCount}
        </LinkButton>
      );
    }

    return <>{reviewCount}</>;
  };

  return (
    <Styled.SellerRatings className={className}>
      <Styled.RatingSection>
        <InfoTitle
          dataTestId="rating"
          title={getRatingTitle()}
          description={ratingCategory ?? <>No rating</>}
          variant="SMALL"
        />
      </Styled.RatingSection>

      <Styled.RatingSection>
        <InfoTitle
          dataTestId="review"
          title={getReviewTitle()}
          description={
            hasRating ? (
              plural('Review', 'Reviews', reviewCount)
            ) : (
              <>
                No reviews <Styled.ConditionalText>yet</Styled.ConditionalText>
              </>
            )
          }
          variant="SMALL"
        />
      </Styled.RatingSection>

      <Styled.RatingSection>
        <InfoTitle
          dataTestId="membership-duration"
          title={membershipDuration ?? 'New'}
          description="on DoneDeal"
          variant="SMALL"
        />
      </Styled.RatingSection>
    </Styled.SellerRatings>
  );
};

export { SellerRatingsSummary };
